module.exports = __webpack_public_path__ + "icomoon.6a9de0ac7c0a74a2ba59.svg";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/icomoon/fonts/icomoon.svg?52ys3h
// module id = ../../../../../src/assets/fonts/icomoon/fonts/icomoon.svg?52ys3h
// module chunks = 1